import { updateUserTaxonomyKeys } from '../updateUserTaxonomyKeys';
import { getUserData } from '@zoopla/user';
import { setupLogger } from '@zoopla/logger';

export type UserTaxonomy = {
    user_uuid?: string | undefined | null;
    user_id?: number | undefined | null;
    registered?: boolean | undefined | null;
    signed_in_status?: string;
    about_me_status?: string | undefined | null;
    registration_platform?: string | undefined | null;
    user_creation_date?: string | undefined | null;
};

/**
 * @deprecated prefer use of trackSegmentAndGAEvent which will append user data
 * provided by UserProvider on page load
 *
 * This is unfortuantely quite engrained in the app and is the cause of lots of
 * async state operations within unit tests, therefore we use readOnly to
 * avoid adding abort controllers everywhere it is used
 */
export const getUserTaxonomy = async (
    abortSignal?: AbortSignal
): Promise<UserTaxonomy> => {
    const logger = setupLogger({
        component: 'tracking',
        custodian: 'platform'
    });

    try {
        const { data, errors } = await getUserData({
            readOnly: true,
            abortSignal
        });

        if (errors && errors.length > 0) {
            logger.error({ err: errors }, 'error getting user taxonomy');
        }

        return updateUserTaxonomyKeys(data?.user);
    } catch (err) {
        logger.error(err);
        return updateUserTaxonomyKeys({});
    }
};
